import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { MemberPayload, VipMemberResponseType } from "types/member";

export const memberApi = {
  async getMemberVip(username: string, payload: MemberPayload) {
    const response = await axiosRequest.post<VipMemberResponseType>(
      "/",
      payloadHelper("MemberVIP", username, payload)
    );
    return response.data;
  },
};
